import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {AlertComponent} from '../directives/alert.component';
import {MyTranslateHttpLoader} from '../i18n/mytranslate-loader';
import {AlertService} from '../services/alert.service';
import {CommonModule} from '@angular/common';
import {NgxWebstorageModule} from 'ngx-webstorage';
import {MyDateFormat} from '../directives/my.date.format';
import {DisplayStartEndSchedule} from '../directives/display.start.end';
import * as moment from 'moment';
import {DisplayMinute} from '../directives/display.minute';
import {TrustHtml} from '../directives/TrustHtml';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {EndOfInterval} from '../directives/EndOfInterval';
import {StartOfInterval} from '../directives/StartOfInterval';
import {NoContentComponent} from '../no-content.component';
import {FocusDirective} from '../directives/FocusDirective';
import {DisplayCurrency} from '../directives/display.currency';
import {NgDragDropModule} from 'ng-drag-drop';
import {MyRound} from '../directives/my.round';
import {DisplayAge} from '../directives/displayAge';
import {DisplayPostalCode} from '../directives/displayPostalCode';
import {DisplayProvinceState} from '../directives/displayProvinceState';
import {DisplayArray} from '../directives/displayArray';
import {ValidateStartEndTimeIntervalDirective} from '../directives/ValidateStartEndTimeIntervalDirective';
import {DisplayInterval} from '../directives/displayInterval';
import {DisplayAvailabilities} from '../directives/displayAvailabilities';
import {DisplayDateInUI} from '../directives/displayDateInUI';
import {RetrieveDateFromUI} from '../directives/retrieveDateFromUI';
import {DisplaySeniority} from '../directives/display.seniority';
import {ValidateHourDirective} from "../directives/ValidateHourDirective";
import {ToNowFormat} from "../directives/toNow.format";
import {FromNowFormat} from "../directives/fromNow.format";
import {DisplayPercent} from "../directives/display.percent";
import {SessionService} from "../services/session.service";

import {SafeArrayAccess} from "../directives/SafeArrayAccess";
import {TransformCR} from "../directives/transform.cr";
import {CutString} from "../directives/CutString";
import {ValidatePasswordDirective} from "../directives/ValidatePasswordDirective";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {Utils} from "../model/Utils";
import {FileSelectDirective} from "./components/upload/file-select.directive";
import {FileDropDirective} from "./components/upload/file-drop.directive";
import {IsVisibleDirective} from "../directives/IsVisibleDirective";


export function createTranslateLoader(http: HttpClient) {
    // return new MyTranslateHttpLoader(http, '/app/i18n/assets/', '.json');
  return new MyTranslateHttpLoader();
}


@NgModule({
    declarations: [ AlertComponent,CutString,
      DisplayAge, DisplayArray, DisplayAvailabilities,
      DisplayCurrency, DisplayDateInUI, DisplayInterval, DisplayMinute,DisplayPercent, DisplayPostalCode, DisplayProvinceState,
      DisplayStartEndSchedule, DisplaySeniority, EndOfInterval,
      FileSelectDirective, FileDropDirective, FocusDirective, FromNowFormat,IsVisibleDirective, MyDateFormat, MyRound, NoContentComponent, RetrieveDateFromUI, SafeArrayAccess, StartOfInterval, ToNowFormat,TransformCR, TrustHtml,
      ValidateHourDirective,ValidatePasswordDirective,
    ValidateStartEndTimeIntervalDirective
    ],
    exports: [ AlertComponent,CutString, DisplayAge, DisplayArray, DisplayAvailabilities, DisplayCurrency, DisplayDateInUI, DisplayInterval, DisplayMinute, DisplayPercent, DisplayPostalCode, DisplayProvinceState, DisplayStartEndSchedule, DisplaySeniority,
      EndOfInterval,
      FileSelectDirective, FileDropDirective, FocusDirective,FromNowFormat,IsVisibleDirective, MyDateFormat, MyRound,
      NoContentComponent, RetrieveDateFromUI, SafeArrayAccess, StartOfInterval, TranslateModule, ToNowFormat,TransformCR, TrustHtml,
      ValidateHourDirective, ValidatePasswordDirective,
      ValidateStartEndTimeIntervalDirective],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        NgbModule,
        NgDragDropModule,
      NgxWebstorageModule.forRoot({prefix: 'client', separator: '.', caseSensitive: true}),
       TranslateModule.forRoot()
        ],
    providers: [AlertService,
      /*{
        provide: ErrorHandler,
        useClass: GlobalErrorHandler
      }*/
    ]

})


export class SharedModule {

    constructor( translate: TranslateService, http: HttpClient, session:SessionService ) {
        //console.log('SharedModule created');

        // translate.addLangs(['fr-CA', 'en']);

      /**
       * I want to have the hour:min 05:00 PM instead of 5:00 PM
       */
      moment.updateLocale('en', {
        longDateFormat : {
          LT: "hh:mm A",
          LTS: "hh:mm:ss A",
          L: "MM/DD/YYYY",
          l: "M/D/YYYY",
          LL: "MMMM Do YYYY",
          ll: "MMM D YYYY",
          LLL: "MMMM Do YYYY LT",
          lll: "MMM D YYYY LT",
          LLLL: "dddd, MMMM Do YYYY LT",
          llll: "ddd, MMM D YYYY LT"
        }
      });
        translate.setDefaultLang('fr-CA');
        createTranslateLoader(http).populateTranslate('fr-CA', translate);
        translate.setDefaultLang('fr-FR');
        createTranslateLoader(http).populateTranslate('fr-FR', translate);

        translate.setDefaultLang('en');
        createTranslateLoader(http).populateTranslate('en', translate);
        translate.use('en');

        if (!Utils.isNullOrUndefined(session.getStoredLocale())){
            // console.log('Found ' + session.getStoredLocale() + ' in localStorage of Browser');
            translate.use(session.getStoredLocale());
            moment.locale(translate.instant('LanguageCode'));
        }else{
           console.log('Navigator: ' + navigator.language);
          if (navigator.language.toLowerCase().indexOf('fr')===0){
            translate.use('fr-CA');
            moment.locale(translate.instant('LanguageCode'));
          }
        }



        // timeZone.
        // console.log('Date DST? ' + moment().isDST() + ' offset: ' + moment().utcOffset() + ' min');
        // console.log('SharedModule setup Language: ' + translate.instant('LanguageDescription') + ', ' + translate.instant('LanguageCode') + ' moment: ' + moment().locale());

    }


}
